/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type WorkOrdersByRegionQueryVariables = Types.Exact<{
  input: Types.WorkOrdersByRegionInput
}>

export type WorkOrdersByRegionQuery = {
  __typename?: 'Query'
  workOrdersByRegion: {
    __typename?: 'WorkOrdersQueryResponse'
    total: number
    workOrders: Array<{
      __typename?: 'WorkOrder'
      createdAt: string
      description: string | null
      dueAt: string | null
      id: string
      orderNumber: number
      priority: Types.WorkOrderPriority | null
      regionID: string | null
      status: Types.WorkOrderStatus
      serviceCategory: Types.WorkOrderServiceCategory | null
      serviceItem: Types.WorkOrderServiceItem
      statusChangedAt: string | null
      createdBy: {
        __typename?: 'BackofficeUser'
        firstName: string
        lastName: string
      } | null
      statusChangedBy: {
        __typename?: 'BackofficeUser'
        firstName: string
        lastName: string
      } | null
      vehicle: {
        __typename?: 'Vehicle'
        id: string
        isWheelchairAccessible: boolean | null
        isSelfDriving: boolean
        label: number | null
        serviceAreaUUID: string
        baseHub: { __typename?: 'Hub'; displayName: string } | null
        currentlyLocatedInHub: { __typename?: 'Hub'; id: string } | null
        fleet: { __typename?: 'Fleet'; name: string } | null
        inVehicleLists: Array<{
          __typename?: 'VehicleList'
          id: string
          name: string
        }>
      } | null
    }>
  }
}

export const WorkOrdersByRegionDocument = gql`
    query workOrdersByRegion($input: WorkOrdersByRegionInput!) {
  workOrdersByRegion(input: $input) {
    total
    workOrders {
      createdAt
      createdBy {
        firstName
        lastName
      }
      description
      dueAt
      id
      orderNumber
      priority
      regionID
      status
      serviceCategory
      serviceItem
      statusChangedAt
      statusChangedBy {
        firstName
        lastName
      }
      vehicle {
        baseHub {
          displayName
        }
        currentlyLocatedInHub {
          id
        }
        fleet {
          name
        }
        id
        isWheelchairAccessible
        isSelfDriving
        label
        serviceAreaUUID
        inVehicleLists {
          id
          name
        }
      }
    }
  }
}
    `

/**
 * __useWorkOrdersByRegionQuery__
 *
 * To run a query within a React component, call `useWorkOrdersByRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrdersByRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkOrdersByRegionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkOrdersByRegionQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkOrdersByRegionQuery,
    WorkOrdersByRegionQueryVariables
  > &
    (
      | { variables: WorkOrdersByRegionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    WorkOrdersByRegionQuery,
    WorkOrdersByRegionQueryVariables
  >(WorkOrdersByRegionDocument, options)
}
export function useWorkOrdersByRegionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkOrdersByRegionQuery,
    WorkOrdersByRegionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    WorkOrdersByRegionQuery,
    WorkOrdersByRegionQueryVariables
  >(WorkOrdersByRegionDocument, options)
}
export function useWorkOrdersByRegionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkOrdersByRegionQuery,
        WorkOrdersByRegionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    WorkOrdersByRegionQuery,
    WorkOrdersByRegionQueryVariables
  >(WorkOrdersByRegionDocument, options)
}
export type WorkOrdersByRegionQueryHookResult = ReturnType<
  typeof useWorkOrdersByRegionQuery
>
export type WorkOrdersByRegionLazyQueryHookResult = ReturnType<
  typeof useWorkOrdersByRegionLazyQuery
>
export type WorkOrdersByRegionSuspenseQueryHookResult = ReturnType<
  typeof useWorkOrdersByRegionSuspenseQuery
>
export type WorkOrdersByRegionQueryResult = Apollo.QueryResult<
  WorkOrdersByRegionQuery,
  WorkOrdersByRegionQueryVariables
>
